import CollapsableMenu from 'components/containers/CollapsableMenu';
import useUserDocuments from 'hooks/requests/user/hooks/useUserDocuments';
import ProfileDocumentsEmpty from 'pages/profile/components/ProfileTabContent/ProfileDocuments/ProfileDocumentsEmpty';
import ProfileDocumentsLoading from 'pages/profile/components/ProfileTabContent/ProfileDocuments/ProfileDocumentsLoading';
import {
  createPrivacySecurityItems,
  DOCS_ON_PRIVACY_SECURITY_ATTRS,
} from 'pages/profile/components/ProfileTabContent/ProfileDocuments/ProfileDocumentsPrivacySecurity/utils';
import React from 'react';
import { getLegalDocuments } from 'utils/documents_utils';

const ProfileDocumentsPrivacySecurity = () => {
  const { userDocuments, loading } = useUserDocuments();
  const legalDocuments = getLegalDocuments(userDocuments);
  const legalDocumentsFiltered = Object.fromEntries(
    Object.entries(legalDocuments).filter(
      ([key]) => Object.keys(DOCS_ON_PRIVACY_SECURITY_ATTRS).indexOf(key) > -1
    )
  );
  const legalDocumentsItems = createPrivacySecurityItems(
    legalDocumentsFiltered
  );

  if (loading) {
    return <ProfileDocumentsLoading />;
  }

  if (legalDocumentsItems.length === 0) {
    return <ProfileDocumentsEmpty />;
  }

  return <CollapsableMenu items={legalDocumentsItems} />;
};

export default ProfileDocumentsPrivacySecurity;
